<template>
    <div class="main">
        <c-panel :title="tituloTela" titleIcon="fas fa-file-signature">
            <div v-if="edit && !carregado" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

            <el-form v-else label-position="top" :model="dados" ref="dados">
                <el-alert v-if="somenteLeitura" :title="'Requisição ' + rotuloStatus + ' — somente leitura.'" type="info" :closable="false" class="u-mb-15"></el-alert>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="5">
                        <el-form-item label="Sentido" prop="sentido" :rules="[$requiredChange]">
                            <el-select v-model="dados.sentido" :disabled="somenteLeitura" style="width:100%;" @change="onSentido">
                                <el-option label="Entrada" value="entrada"></el-option>
                                <el-option label="Saída" value="saida"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7" v-if="ehSmed">
                        <el-form-item label="Instituição" prop="instituicao_id" :rules="[$requiredChange]">
                            <el-select v-model="dados.instituicao_id" :disabled="somenteLeitura" filterable placeholder="Selecione" style="width:100%;">
                                <el-option v-for="i in $store.state.instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Tipo de Solicitação">
                            <el-select v-model="dados.tipo_solicitacao_id" :disabled="somenteLeitura" filterable clearable placeholder="Selecione" style="width:100%;">
                                <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Data">
                            <el-date-picker v-model="dados.data_requisicao" :disabled="somenteLeitura" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10" v-if="dados.sentido === 'entrada'">
                        <el-form-item label="Fornecedor (entrada)">
                            <el-select v-model="dados.fornecedor_id" :disabled="somenteLeitura" filterable clearable placeholder="Selecione o fornecedor" style="width:100%;">
                                <el-option v-for="f in fornecedores" :key="f.id" :label="f.nome" :value="f.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Documento (NF/Req.)">
                            <el-input v-model="dados.documento" :disabled="somenteLeitura" maxlength="60"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="dados.sentido === 'entrada' ? 8 : 18">
                        <el-form-item label="Observação">
                            <el-input v-model="dados.observacao" :disabled="somenteLeitura"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <h4>Itens</h4>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Produto</th>
                            <th style="width: 130px;">Quantidade</th>
                            <th style="width: 130px;">Lote</th>
                            <th style="width: 150px;">Validade</th>
                            <th style="width: 50px;" v-if="!somenteLeitura"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(it, i) in dados.itens" :key="i">
                            <td>
                                <el-select v-model="it.produto_id" :disabled="somenteLeitura" filterable remote clearable :remote-method="q => buscarProduto(q, i)" placeholder="Digite..." style="width:100%;">
                                    <el-option v-for="p in (produtosPorLinha[i] || produtoOpcoes(it))" :key="p.id" :label="`${p.codigo} — ${p.nome}`" :value="p.id"></el-option>
                                </el-select>
                            </td>
                            <td><el-input-number v-model="it.quantidade" :disabled="somenteLeitura" :min="0.001" :precision="3" controls-position="right" style="width:100%;"></el-input-number></td>
                            <td><el-input v-model="it.lote" :disabled="somenteLeitura" maxlength="60"></el-input></td>
                            <td><el-date-picker v-model="it.validade" :disabled="somenteLeitura" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker></td>
                            <td v-if="!somenteLeitura"><el-button size="mini" type="danger" plain icon="el-icon-delete" @click="dados.itens.splice(i, 1)"></el-button></td>
                        </tr>
                        <tr v-if="!dados.itens.length"><td :colspan="somenteLeitura ? 4 : 5" class="u-text-center" style="color:#909399; padding:10px;">Nenhum item.</td></tr>
                    </tbody>
                </table>
                <el-button v-if="!somenteLeitura" size="small" plain icon="el-icon-plus" @click="addItem">+ ITEM</el-button>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/almox-requisicao"><el-button>VOLTAR</el-button></router-link>
                        <el-button class="u-ml-10" v-if="!somenteLeitura" type="primary" @click="salvar">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        edit: false,
        carregado: false,
        tipos: [],
        fornecedores: [],
        produtosPorLinha: {},
        status: 1,
        dados: {
            sentido: 'entrada',
            instituicao_id: '',
            tipo_solicitacao_id: null,
            fornecedor_id: null,
            data_requisicao: '',
            documento: '',
            observacao: '',
            itens: []
        }
    }),
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        somenteLeitura () { return this.edit && this.status !== 1 },
        rotuloStatus () { return { 1: 'Aberta', 2: 'Efetivada', 3: 'Cancelada' }[this.status] || '' },
        tituloTela () {
            if (!this.edit) return 'NOVA REQUISIÇÃO'
            return this.somenteLeitura ? 'REQUISIÇÃO (VISUALIZAÇÃO)' : 'EDITAR REQUISIÇÃO'
        }
    },
    mounted () {
        this.carregarTipos()
        this.carregarFornecedores()
        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.dados.instituicao_id = this.$store.state.config.instituicao.id
        }
        this.dados.data_requisicao = this.$moment().format('YYYY-MM-DD')
        if (this.$route.params.id) {
            this.edit = true
            this.carregar(this.$route.params.id)
        } else {
            this.addItem()
        }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        carregarTipos () {
            this.$axios.get(`${this.baseUrl()}/api/almox-tipo-solicitacao/getAll?situacao=true`, this.$store.getters.getHeaderAuth)
                .then(r => { this.tipos = r.data || [] }).catch(e => this.$store.commit('throwException', e))
        },
        carregarFornecedores () {
            this.$axios.get(`${this.baseUrl()}/api/almox-fornecedor/getAll?situacao=true`, this.$store.getters.getHeaderAuth)
                .then(r => { this.fornecedores = r.data || [] }).catch(e => this.$store.commit('throwException', e))
        },
        onSentido () { if (this.dados.sentido !== 'entrada') this.dados.fornecedor_id = null },
        addItem () { this.dados.itens.push({ produto_id: null, quantidade: 1, lote: '', validade: null, produto: null }) },
        produtoOpcoes (it) { return it.produto ? [it.produto] : [] },
        buscarProduto (q, idx) {
            if (!q || q.length < 2) return
            this.$axios.post(`${this.baseUrl()}/api/almox-produto/getAllPaginate`, { busca: q, situacao: true }, this.$store.getters.getHeaderAuth)
                .then(r => { this.$set(this.produtosPorLinha, idx, (r.data && r.data.data) ? r.data.data : []) })
        },
        carregar (id) {
            this.$axios.get(`${this.baseUrl()}/api/almox-requisicao/getById/${id}`, this.$store.getters.getHeaderAuth).then(r => {
                const reg = r.data || {}
                this.status = reg.status
                this.dados = {
                    sentido: reg.sentido,
                    instituicao_id: reg.instituicao_id,
                    tipo_solicitacao_id: reg.tipo_solicitacao_id,
                    fornecedor_id: reg.fornecedor_id,
                    data_requisicao: reg.data_requisicao ? this.$moment(reg.data_requisicao).format('YYYY-MM-DD') : '',
                    documento: reg.documento || '',
                    observacao: reg.observacao || '',
                    itens: (reg.itens || []).map(it => ({
                        produto_id: it.produto_id,
                        quantidade: Number(it.quantidade),
                        lote: it.lote || '',
                        validade: it.validade ? this.$moment(it.validade).format('YYYY-MM-DD') : null,
                        produto: it.produto || null
                    }))
                }
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                const itensValidos = this.dados.itens.filter(it => it.produto_id && it.quantidade > 0)
                if (!itensValidos.length) { window.eventBus.$emit('alert', { msg: 'Informe pelo menos um item com produto e quantidade.', type: 'warning' }); return }

                window.eventBus.$emit('loading', true)
                const payload = { ...this.dados, itens: itensValidos }
                const url = this.edit
                    ? `${this.baseUrl()}/api/almox-requisicao/update/${this.$route.params.id}`
                    : `${this.baseUrl()}/api/almox-requisicao/store`
                this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.$router.push('/admin/almox-requisicao')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
